import API, { defaultHeaders } from '@/api';

const fetchCreate = payload => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}/panel/tag-create/`, {
    headers,
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export default fetchCreate;
